import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindNouveautesContent($id: String!)
{
  findNouveautesContent(id: $id) {
    data {

      noveltiesSuperTitle { iv }
      noveltiesTitle { iv }
      noveltiesFontSizeTitle { iv }
      noveltiesSubTitle { iv }
      noveltiesFontSizeSubTitle { iv }
      noveltiesTextColor { iv }
      noveltiesCtaText { iv }
      noveltiesCtaLink { iv }
      noveltiesCtaStyle { iv }
      noveltiesBackgroundColor { iv }
      products {
        iv {
          id
          hideBrandName
          hideProductName
          hidePrice
        }
      }
    }
  }
}`,
]);
